(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvWorkflowDefinitionList', drvWorkflowDefinitionList);

    drvWorkflowDefinitionList.$inject = [];
    
    /**
     * Directive for loading, displaying and modifying workflow definitions in a list display
     *
     */
    function drvWorkflowDefinitionList () {
        var directive = {
            restrict: 'EA',
            scope: {},
            controller: WorkflowDefinitionListCtrl,
            controllerAs: 'vm',
            templateUrl: 'app/workflow/workflow-definition-list.tmpl.html'
        };
        return directive;
    }

    WorkflowDefinitionListCtrl.$inject = [
        '$scope',
        '$location',
        '$q',
        'WorkflowService',
        'WorkflowRunService',
        'DialogService',
        'NavigationAidService',
        'SystemService'];

    function WorkflowDefinitionListCtrl(
        $scope,
        $location,
        $q,
        WorkflowService,
        WorkflowRunService,
        DialogService,
        NavigationAidService,
        SystemService) {
        /* jshint validthis:true */
        var vm = this;
        vm.loading = true;
        vm.allWorkflowsSelected = false;
        vm.workflowDefinitions = [];
        vm.searchText = '';
        vm.searchDelay = SystemService.getSearchDelay();
        vm.deleteWorkflow = deleteWorkflow;
        vm.deleteWorkflows = deleteWorkflows;
        vm.runWorkflow = runWorkflow;
        vm.newWorkflow = newWorkflow;
        vm.close = close;
        vm.updateList = loadWorkflowDefinitions;
        vm.loadCount = loadCount;
        vm.copyWorkflows = copyWorkflows;
        vm.workflowDefinitionsListPage = 1;
        vm.workflowDefinitionsCount = 0;
        vm.showDeleted = false;
        Object.defineProperty(vm, 'selectedWorkflows', {
            get: function () {
                return _(vm.workflowDefinitions)
                    .filter('Selected')
                    .value();
            }
        });
        Object.defineProperty(vm, 'titleText', { get: getTitleText });

        activate();

        function activate() {
            SystemService.getMenuListSize('Workflow Definitions')
                .then(getListPageSizeOk, getListPageSizeError);

            function getListPageSizeOk(data) {
                vm.workflowDefinitionsListPageSize = data;

                $scope.$watch('vm.searchText', function (newVal, oldVal) {
                    if (newVal !== oldVal) {
                        loadWorkflowDefinitions();
                    }
                });

                $scope.$watch('vm.showDeleted', function (newVal, oldVal) {
                    if (newVal !== oldVal) {
                        loadWorkflowDefinitions();
                        loadCount();
                    }
                });

                loadWorkflowDefinitions();
                loadCount();
            }

            function getListPageSizeError(response) {
                DialogService.error('Error fetching list size', response);
            }
        }

        /**
         * Load the workflow definitions. Result is used to populate the workflow definition list.
         */
        function loadWorkflowDefinitions() {
            if (loadWorkflowDefinitions.currentPromise === undefined) {
                loadWorkflowDefinitions.currentPromise = null;
            }
            vm.loading = true;
            var getPromise = WorkflowService.query({
                pageSize: vm.workflowDefinitionsListPageSize,
                currentPage: vm.workflowDefinitionsListPage,
                genericSearch: vm.searchText
            })
                .then(loadWorkflowDefinitionsOk, loadWorkflowDefinitionsError)
                .then(function () {
                    vm.loading = false;
                });

            loadWorkflowDefinitions.currentPromise = getPromise;

            return getPromise;

            function loadWorkflowDefinitionsOk(data) {
                if (getPromise === loadWorkflowDefinitions.currentPromise) {
                    vm.workflowDefinitions = data.Items;
                    vm.workflowDefinitionsCount = data.ItemCount;
                    vm.allWorkflowsSelected = false;
                }
                else {
                    return $q.reject();
                }
            }

            function loadWorkflowDefinitionsError(response) {
                if (getPromise === loadWorkflowDefinitions.currentPromise) {
                    vm.workflowDefinitionsError = response;
                }
                else {
                    return $q.reject();
                }
            }
        }

        function loadCount() {
            return WorkflowService.count(vm.showDeleted)
                .then(loadCountOk, loadCountError);

            function loadCountOk(count) {
                vm.totalCount = count;
            }

            function loadCountError(response) {
            }
        }

        /**
         * Delete the specified workflow.
         *
         * @param {number} id - Id of workflow to delete
         */
        function deleteWorkflow(id) {
            DialogService
                .confirm('Delete the selected workflow definition?', 'Workflow definition delete confirm')
                .then(deleteOk);

            function deleteOk() {
                WorkflowService.remove(id)
                    .then(deleteOk, deleteError);

                function deleteOk() {
                    vm.loading = true;
                    loadWorkflowDefinitions().then(function () {
                        vm.loading = false;
                    });
                    loadCount();
                }

                function deleteError(response) {
                    DialogService.error('Error deleting Workflow definition', response);
                }
            }
        }

        /**
         * Delete the workflows selected in the list.
         */
        function deleteWorkflows() {
            var selectedWorkflowIds = _.map(vm.selectedWorkflows, 'Id');
            var workflowLabel = 'Workflow';
            if (selectedWorkflowIds.length > 1) {
                workflowLabel += 's';
            }

            if (ensureWorkflowsSelection()) {
                DialogService
                    .confirm('Delete the ' + selectedWorkflowIds.length + ' selected ' + workflowLabel + '?', 'Delete ' + workflowLabel + ' confirm')
                    .then(deleteWorkflowsConfirmed);
            }

            function deleteWorkflowsConfirmed() {
                WorkflowService.multiDelete(selectedWorkflowIds)
                    .then(deleteWorkflowsOk, deleteWorkflowsError);
            }

            function deleteWorkflowsOk(success) {
                loadWorkflowDefinitions();
                loadCount();
            }

            function deleteWorkflowsError(response) {
                DialogService.error('Error deleting ' + workflowLabel, response);
            }
        }

        /**
         * Start a new instance of the specified workflow.
         */
        function runWorkflow(definitionId) {
            return WorkflowRunService.createInstance(definitionId)
                .then(runWorkflowOk, runWorkflowError);

            function runWorkflowOk(instanceId) {
                $location.url('/runworkflow/' + instanceId);
            }

            function runWorkflowError(response) {
                DialogService.error('Error starting workflow', response);
            }
        }

        /**
         * Redirects to the new workflow route
         */
        function newWorkflow() {
            $location.url('/workflow/new');
        }

        /**
         * Ensure at least one workflow is selected.
         * Displays a dialog 'No workflows were selected' if no workflows are selected.
         * @return {bool} true if at least one workflow is selected, else false
         */
        function ensureWorkflowsSelection() {
            if (vm.selectedWorkflows.length === 0) {
                DialogService.alert('No Workflows were selected');
                return false;
            } else {
                return true;
            }
        }

        /**
         * Copy the workflows selected in the list.
         */
        function copyWorkflows() {
            var selectedWorkflowIds = _.map(vm.selectedWorkflows, 'Id');
            var workflowLabel = 'Workflow';
            if (selectedWorkflowIds.length > 1) {
                workflowLabel += 's';
            }

            if (ensureWorkflowsSelection()) {
                DialogService
                    .confirm('Copy the ' + selectedWorkflowIds.length + ' selected ' + workflowLabel + '?', 'Copy ' + workflowLabel + ' confirm')
                    .then(copyWorkflowsConfirmed);
            }

            function copyWorkflowsConfirmed() {
                WorkflowService.multiCopy(selectedWorkflowIds)
                   .then(copyOk, copyError);
            }

            function copyOk() {
                loadWorkflowDefinitions();
                loadCount();
            }

            function copyError(response) {
                DialogService.error('Error copying ' + workflowLabel, response);
            }
        }

        /**
         * When the view is 'closed' navigation to a previous page should occur.
         */
        function close() {
            NavigationAidService.goBack();
        }

        /**
         * Gets the view title
         *
         * @returns {string}
         */
        function getTitleText() {
            var result = '';

            if (vm.showDeleted === true) {
                result += 'Deleted ';
            }

            result += 'Workflows';

            return result;
        }
    }
})();